import { render, staticRenderFns } from "./AddressVerification.vue?vue&type=template&id=d959d1ce&scoped=true"
import script from "./AddressVerification.vue?vue&type=script&lang=js"
export * from "./AddressVerification.vue?vue&type=script&lang=js"
import style0 from "./AddressVerification.vue?vue&type=style&index=0&id=d959d1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d959d1ce",
  null
  
)

export default component.exports